module.exports = __webpack_public_path__ + "static/img/4.0f3a433.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/4.png
// module id = M36D
// module chunks = 1